export default __webpack_public_path__ + "static/media/Summoner's Leggings of Imperial Assent.85df46e5.jpg";